<template>
  <apexchart ref="chart" type="line" height="400" :options="this.chartOptions" :series="series"/>
</template>

<script>
let colors = ['#dc3545', '#007bff', '#28a745', '#ffc107'];
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: "Title"
    },
    series: {
      type: Array,
    },
  },
  data() {
    let vm = this;
    let options = function (index, oppositeFlag) {
      const show = (index === 0 || oppositeFlag);

      let series = (index < vm.series.length) ? vm.series[index] : Object.assign({}, vm.series[0]);
      if (index >= vm.series.length) {
        series.name = '';
      }
      return {
        seriesName: series.name,
        title: {
          text: series.dimension.replace(/<[^>]+>/g, ''),
          style: {
            color: '#1d2124',
          }
        },
        show: show,
        opposite: oppositeFlag,
        min: series.min,
        max: series.max,
        axisTicks: {
          show: show,
        },
        axisBorder: {
          show: show,
          color: '#1d2124'
        },
        labels: {
          style: {
            color: '#1d2124',
          },
          minWidth: 1,
          maxWidth: 160,
        },
        tooltip: {
          enabled: false
        }
      }
    };

    var yaxis = [];
    this.series.forEach((item, i, series) => {
      yaxis.push(options(i, i > 0 && i === series.length - 1));
    });

    if (this.series.length === 1) {
      yaxis.push(options(1, true));
    }

    return {
      chartOptions: {
        chart: {
          id: this.id,
          group: 'ChartGroup1',
          shadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 1
          },
          toolbar: {
            show: false
          }
        },
        colors: colors,
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 3,
          curve: 'smooth'
        },
        title: {
          text: this.title,
          align: 'center'
        },
        markers: {
          size: 3,
          hover: {
            size: 6
          }
        },
        xaxis: {
          type: 'line',
          title: {
            text: ''
          },
        },
        yaxis: yaxis,
        legend: {
          position: 'top',
          horizontalAlign: 'center',
          floating: false,
          offsetY: 0,
          offsetX: 0,

          show: true,
          fontSize: '12px',
          fontFamily: 'Helvetica, Arial',
          markers: {
            width: 6,
            height: 6,
            radius: 8,
          },
          onItemClick: {
            toggleDataSeries: true
          },
          onItemHover: {
            highlightDataSeries: false
          },
        },
        tooltip: {
          followCursor: false,
          theme: 'dark',
          x: {
            show: false,
          },
          marker: {
            show: true,
          },
          y: {
            title: {
              formatter: function () {
                return ''
              }
            }
          }
        },
      }
    }
  },
  methods: {
    updateSeries(series) {
      this.$refs.chart.updateSeries(series);
    }
  }
}
</script>